<template>
    <b-container>
        <b-card
            title="Stakes"
        >
        <b-button
            v-if="isInRole('canCreateStake')"
            class="mb-3" 
            :to="{name: 'stake-add'}" 
            variant="outline-secondary"> Create Stake <font-awesome-icon icon="plus" /></b-button>
        <b-table
            :fields="table.fields"
            :items="table.items"
            class="mb-3"
            show-empty
            empty-text="No stakes to show"            
            outlined>
        <template v-slot:cell(view)="row">
                <b-button :key="row.item.uid" :to="{name: 'stake-detail', params: { 'stakeId': row.item.stake_id}}" variant="outline-secondary"> 
                <font-awesome-icon icon="eye" />
                </b-button>
        </template>
        </b-table>
        </b-card>
    </b-container>
</template>
<script>
import { StakeApi } from "@/app/stakes/stakeApi";
import StakeDetail from "@/app/stakes/StakeDetail";
import { userMixin } from "@/mixins/userMixin";
import handleError from '@/errorHandler';
export default {
    props: {},
    name: "StakeList",
    mixins: [userMixin],
    components: { StakeDetail },
    data () {
        return {
            table: {
                id: "stake-table",
                fields: [
                    {
                        key: "stake_name",
                        label: "Stake Name"
                    },
                    {
                        key: "stake_city",
                        label: "City"
                    },
                    {
                        key: "view",
                        label: "View"
                    }
                ],
                items: [],
                totalRows: 0,
                page: {
                    index: 1,
                    size: 5
                }
            }
        }
    },
    async mounted() {
        await this.searchStakes();
    },
    watch: {},
    computed: {},
    methods: {
        async searchStakes() {
            try{
                const { data } = await StakeApi.getStakeList();
                //console.log(data);
                this.table.items = data;
            }catch(e){
                const msg = "Unable to get Stake List";
                handleError(e, msg);

            }
        }
    }    
}
</script>
<style lang="scss" scoped>
</style>
